/**
 * Email Protection Module
 * Assembles email addresses from data attributes to protect against spam bots
 */

export function initEmailProtection(): void {
  const emailLinks = document.querySelectorAll<HTMLAnchorElement>('.email-protected');

  emailLinks.forEach(link => {
    const name = link.dataset.name;
    const domain = link.dataset.domain;

    if (name && domain) {
      const email = `${name}@${domain}`;

      // Set href for mailto
      link.href = `mailto:${email}`;

      // Set visible text (replace placeholder)
      link.textContent = email;
    }
  });
}
